import { Progress } from "react-sweet-progress";
import { colors } from "../../../lib/design";
import { OverlayTrigger, Popover } from "react-bootstrap";
import React from "react";

const ImpressionsProgress = props => {
  const { campaignItem, ...rest } = props;

  const currentBudget = campaignItem.budget?.current ?? 0;
  const totalBudget = campaignItem.budget?.total ?? 1;

  let donePercentage = 0;
  if (campaignItem.budget) {
    donePercentage = Math.min((currentBudget / totalBudget) * 100, 100).toFixed(2);
  }

  const overlay = (
    <Popover id={"impressions-popover"} bsClass={" popover"}>
      Progress {donePercentage}%
    </Popover>
  );

  return (
    <OverlayTrigger trigger={["hover", "focus"]} placement={"top"} overlay={overlay}>
      <div className={"m-lxs"} {...rest}>
        <Progress
          type={"circle"}
          percent={donePercentage}
          width={20}
          strokeWidth={20}
          theme={{
            default: { symbol: " ", trailColor: "rgba(0, 0, 0, 0.1)" },
            success: { symbol: " ", color: colors.primaryColor, trailColor: "rgba(0, 0, 0, 0.1)" },
          }}
          status={"success"}
          style={{ marginBottom: "10px" }}
        />
      </div>
    </OverlayTrigger>
  );
};

export default ImpressionsProgress;
